module.exports = __webpack_public_path__ + "img/b5.935133f4.jpg";